import { useNavigate, useParams } from "react-router-dom";
import { CollectionStats } from "../../stats/CollectionStats"
import { useSelector } from "react-redux";
import { selectEditingCollection } from "../../../redux/features/appData";
import { useEffect } from "react";

type WazKBAnalyticsProps = {

}

export const WazKBAnalytics = ({} : WazKBAnalyticsProps) => {

    const navigate = useNavigate();

    const { collectionId } = useParams();

    const editingCollection = useSelector(selectEditingCollection);

    useEffect(() => {
        if (!collectionId) {
            navigate("/waz/kb/analytics/" + editingCollection?.id);
        }
    }, [collectionId]);

    return (
        <CollectionStats />
    )
}